import { useLocation } from 'react-router';

import { ComingSoonTag } from '@/components/coming-soon-tag';
import { NAV_GROUPS } from '@/config/navigation';

export default function PlaceholderRoute() {
  const { pathname } = useLocation();
  const slug = pathname.startsWith('/') ? pathname.slice(1) : pathname;
  const item = NAV_GROUPS.flatMap((group) => group.items).find((i) => i.slug === slug);

  if (!item) {
    return (
      <div className="p-6">
        <h1 className="text-2xl font-semibold">Section not found</h1>
      </div>
    );
  }

  return (
    <div className="p-6">
      <h1 className="flex items-center gap-2 text-2xl font-semibold">
        {item.label}
        {item.comingSoon && <ComingSoonTag />}
      </h1>
    </div>
  );
}
